import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LeafBannerToast } from "../../common/leaf/LeafBannerToast/LeafBannerToast";
import { LeafModal } from "../../common/leaf/LeafModal/LeafModal";
import defaultContent from "../../content/browser";
import "./GrayListBanner.scss";

export const GrayListBanner = ({ show }: { show: boolean }) => {
  const [showReadMoreModal, setShowReadMoreModal] = useState(false);
  const { t } = useTranslation(["browser"]);

  const handleModalOnClose = () => {
    setShowReadMoreModal(false);
  };

  const handleModalOpen = () => {
    setShowReadMoreModal(true);
  };

  return (
    <>
      {show && (
        <LeafBannerToast theme="yellow" closeFunction={() => {}} show={true} id="hasSeenGraylistWarning">
          <section className="grayListBanner">
            <span className="grayListBanner__title">
              {t("browserNotSupported", defaultContent["browserNotSupported"])}
            </span>
            <p className="grayListBanner__message">{t("browserBanner", defaultContent["browserBanner"])}</p>
            <span
              className="grayListBanner__readMoreLink"
              onClick={handleModalOpen}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleModalOpen();
                }
              }}
              role="link"
              tabIndex={0}
            >
              {t("readMoreLink", defaultContent["readMoreLink"])}
            </span>
          </section>
          <LeafModal
            title={`${t("bannerModal", defaultContent["bannerModal"])}`}
            open={showReadMoreModal}
            onCloseCallbackFn={handleModalOnClose}
            id={"grayListBanner"}
          >
            <ul className="grayListBanner__browserList">
              <li>{t("chrome", defaultContent["chrome"])}</li>
              <li>{t("safari", defaultContent["safari"])}</li>
              <li>{t("firefox", defaultContent["firefox"])}</li>
              <li>{t("edge", defaultContent["edge"])}</li>
            </ul>
          </LeafModal>
        </LeafBannerToast>
      )}
    </>
  );
};
